const columnsCollections = [...document.querySelectorAll('.collection-grid__single')]
!! columnsCollections && columnsCollections.map(column => {
  const icon = column.querySelector('.icon')
  icon.addEventListener('click', () => {
    column.classList.toggle('active')
  })
})

new Swiper('.swiper__thumbs', {
  direction: window.innerWidth > 964 ? 'vertical' : 'horizontal',
  speed: 400,
  spaceBetween: 10,
  loop: true,
  slidesPerView: 3,
  centeredSlides: true,
  navigation: {
    nextEl: '.thumbnails-wrapper .swiper-button-next',
    prevEl: '.thumbnails-wrapper .swiper-button-prev'
  }
});
